import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { paths } from "@libs/paths";
import styles from "./terms.module.css";
import type { NextPage } from "next";

const TermsPage: NextPage = () => {
  return (
    <CommonLayout noHeaderButton noModal hasFooter>
      <CommonHead title={"利用規約"} ogUrl={paths.terms} />
      <div className={styles.terms}>
        <main className={styles.main}>
          <div className={styles.inner}>
            <div className={styles.termsTitle}>
              <h1>Fansta利用規約</h1>
            </div>
            <p className={styles.termsDate}>
              2021年3月29日&emsp;制定
              <br />
              2022年10月3日&emsp;改定
            </p>
            <ul>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第1条&emsp;はじめに</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;Fansta（以下「本サービス」といいます）とは、株式会社MIXI（以下「弊社」といいます）が運営するスポーツ観戦施設（飲食店を含みますがそれに限られません。以下同じ。）情報掲載サービスおよびそれに付随するサービスのことです。本サービスをご利用になるにはこのFansta利用規約（以下「本規約」といいます）に同意のうえご利用ください。本サービスの利用者（以下「ユーザー」といいます）は、本規約の全ての記載内容について同意するものとします。
                  </p>
                  <p>
                    2&emsp;弊社は、本サービスにおける掲載または個別の電子メールによる送信その他適切な方法によって、変更内容および変更の時期を周知することにより、本規約を変更することができるものとします。変更後の本規約は、弊社が別途定める場合を除いて、本サービス上に表示した後に初めてユーザーが本サービスを利用した時点より効力を生じるものとします。
                  </p>
                  <p>
                    3&emsp;本サービスには、本規約およびその他の規約等において、利用条件が規定されています。その他の規約等は名称の如何に関わらず本規約の一部を構成するものとします。
                  </p>
                  <p>
                    4&emsp;本規約の規定とその他の規約等の規定が矛盾する場合は、弊社が別途定める場合を除いて、本規約の規定が優先して適用されるものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第2条&emsp;アカウント登録
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;本サービスのすべての機能を利用する場合は、本規約の内容に同意した上で、弊社所定の方法により、アカウント登録を行うものとします。
                  </p>
                  <p>
                    2&emsp;未成年者が本サービスを利用する場合には、親権者の同意を得て利用するものとします。
                  </p>
                  <p>
                    3&emsp;ユーザーが次の各号のいずれかに該当する場合には、利用をお断りする場合があります。
                    <br />
                    (1)&emsp;本条第1項の方法によらずにアカウント登録を行った場合
                    <br />
                    (2)&emsp;過去に本規約に違反したことを理由として何らかの処分を受けた者である場合
                    <br />
                    (3)&emsp;弊社が提供する他のサービスにおいて何らかの処分を受けたことがある場合
                    <br />
                    (4)&emsp;その他弊社が不適切と判断した場合
                    <br />
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第3条&emsp;アカウントの管理
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーは、自己のアカウント登録に必要な所定の情報（電話番号、メールアドレスを含みますがそれに限られません。以下同じ。）の不正利用の防止に努めるとともに、その管理について一切の責任を持つものとします。
                  </p>
                  <p>
                    2&emsp;ユーザーは前項の情報について、真実かつ自己自身の情報であり、利用可能であることを保証するものとし、当該情報に変更があった場合は、速やかに弊社所定の方法で変更するものとします。
                  </p>
                  <p>
                    3&emsp;ユーザーはいかなる場合においても、アカウントを第三者に譲渡または貸与することはできません。
                  </p>
                  <p>
                    4&emsp;ユーザーは1人につき1つのアカウントを保有するものとします。複数人が1つのアカウントを共同して保有することはできません。
                  </p>
                  <p>
                    5&emsp;本サービスに登録した情報について、ユーザーは必要に応じてバックアップを取るものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第4条&emsp;利用環境の整備
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーは、本サービスを利用するために必要なあらゆる機器、ソフトウェア、通信手段を自己の責任と費用において、適切に整備するものとします。
                  </p>
                  <p>
                    2&emsp;ユーザーは自己の利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセスおよび情報漏洩の防止等のセキュリティ対策を講じるものとします。
                  </p>
                  <p>
                    3&emsp;弊社はユーザーの利用環境について一切関与せず、また一切の責任を負いません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第5条&emsp;本サービスの内容
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーは自己のアカウント登録に必要な所定の情報（以下「登録情報」といいます）を登録するものとします。
                  </p>
                  <p>
                    2&emsp;本サービスで掲載されているスポーツ観戦施設の情報（以下、「掲載情報」といいます。）は、当該スポーツ観戦施設を運営する第三者が掲載しておりますので、当該スポーツ観戦施設に直接ご確認ください。掲載情報について、弊社は一切責任を負いません。
                  </p>
                  <p>
                    3&emsp;本サービスで掲載している観戦できるスポーツの試合スケジュールやチーム名、ロゴ等は、公式の情報やスポーツ観戦施設からの情報をもとに提供しておりますが、その正確性を保証するものではありません。変更があった場合等は反映されていない可能性もありますので、利用者の責任において公式サイトなどで正確な情報はご確認ください。
                  </p>
                  <p>
                    4&emsp;掲載情報の内容について、弊社が不適切と判断した場合は、本サービスにおいて当該スポーツ観戦施設の掲載を中止することなどがありますが、弊社がその義務を負うものではありません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第6条&emsp;サービスの変更等
                </h2>
                <div className={styles.detailText}>
                  <p>
                    弊社は、弊社の都合により、本サービスをいつでも任意の理由で、追加、変更、中断、終了することができます。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第7条&emsp;利用料金等</h2>
                <div className={styles.detailText}>
                  <p>1&emsp;本サービスは原則として無料とします。</p>
                  <p>
                    2&emsp;弊社が、本サービスの使用の対価を求める場合にはユーザーに事前に通知し同意を得るものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第8条&emsp;登録情報に関する権利と責任
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;登録情報に関する権利は、登録したユーザーに帰属します。
                  </p>
                  <p>
                    2&emsp;登録情報に関する責任は、ユーザー自身にあります。ユーザーは自ら登録情報を適切に管理するものとします。
                  </p>
                  <p>
                    3&emsp;ユーザーは、弊社に対し、当該登録情報が弊社または第三者の権利を侵害していないことを保証するものとします。ユーザーが弊社または第三者の名誉を毀損した場合、プライバシー権を侵害した場合、許諾なく弊社または第三者の個人情報を開示した場合、著作権法に違反する行為を行った場合その他弊社または第三者の権利を侵害した場合は、当該ユーザーは自己の責任と費用において解決するものとします。
                  </p>
                  <p>
                    4&emsp;ユーザーは、登録情報について、ユーザー自身の自己責任においてバックアップをとるものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第9条&emsp;本サービスの権利等
                </h2>
                <div className={styles.detailText}>
                  <p>
                    登録情報を除き、掲載情報およびその他の情報の著作権およびその他の知的財産権を含む一切の権利は弊社または第三者に帰属します。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第10条&emsp;個人情報の取り扱い
                </h2>
                <div className={styles.detailText}>
                  <p>
                    弊社は、個人情報を「
                    <a
                      className={styles.link}
                      href={paths.privacyPolicy}
                      target="_blank"
                    >
                      プライバシーポリシー
                    </a>
                    」に基づき、適切に取り扱うものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第11条&emsp;アカウント削除
                </h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーがアカウント削除を希望する場合には、当該ユーザーは、弊社所定の方法により、アカウント削除を行うものとします。
                  </p>
                  <p>
                    2&emsp;弊社は、ユーザーが次の各号に掲げるいずれかに該当する場合には、弊社の判断によって、強制的にユーザーのアカウントを削除して本サービスの利用をお断りすることがあります。
                    <br />
                    (1)&emsp;第2条第1項の方法によらずにアカウント登録を行ったことが明らかとなった場合
                    <br />
                    (2)&emsp;本規約に違反した場合
                    <br />
                    (3)&emsp;弊社が提供する他のサービスにおいて何らかの処分を受けたことがある場合
                    <br />
                    (4)&emsp;その他弊社が不適切と判断した場合
                  </p>
                  <p>
                    3&emsp;アカウント削除を行うと当該ユーザーに関する情報が削除され、いかなる場合であっても復元できません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第12条&emsp;禁止事項</h2>
                <div className={styles.detailText}>
                  <p>
                    ユーザーは、本サービスの利用にあたり、次に掲げる行為を行ってはならないものとします。
                    <br />
                    (1)&emsp;弊社もしくは第三者の著作権、商標権等の知的財産権を侵害する行為、または侵害するおそれのある行為。
                    <br />
                    (2)&emsp;弊社もしくは第三者の財産、プライバシーもしくは肖像権を侵害する行為、または侵害するおそれのある行為。
                    <br />
                    (3)&emsp;弊社もしくは第三者を不当に差別もしくは誹謗中傷し、弊社もしくは第三者への不当な差別を助長し、またはその名誉もしくは信用を毀損する行為。{" "}
                    <br />
                    (4)&emsp;自分以外の人物を名乗ったり、代表権や代理権がないにもかかわらずあるものと装ったり、または他の人物や組織と提携、協力関係にあると偽る行為。
                    <br />
                    (5)&emsp;複数人が1つのアカウントを共同して保有する行為。
                    <br />
                    (6)&emsp;本サービスの一部または全部を他のウェブサイトやアプリケーションに取り込む行為。
                    <br />
                    (7)&emsp;弊社の設備に蓄積された情報を不正に書き換え、または消去する行為。
                    <br />
                    (8)&emsp;ウィルス等の有害なコンピュータプログラム等を送信または掲載する行為。
                    <br />
                    (9)&emsp;弊社または第三者のサーバーに負担をかける行為、もしくは、本サービスの運営やネットワーク・システムに支障を与える行為、またはこれらのおそれのある行為。
                    <br />
                    (10)&emsp;その行為が前各号のいずれかに該当することを知りつつ、その行為を助長する目的でリンクを貼る行為。
                    <br />
                    (11)&emsp;法令、公序良俗に違反し、または弊社もしくは第三者の権利を侵害すると弊社が判断する行為。
                    <br />
                    (12)&emsp;その他、他のユーザーに迷惑をかける行為等の弊社が不適切と判断する行為。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第13条&emsp;広告等</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;弊社は、本サービス上に広告を表示することができるものとします。
                  </p>
                  <p>
                    2&emsp;弊社は、ユーザーに対して新サービスの告知、広告配信、サービス運営上の事務連絡、その他情報の提供をメールなどの手段で直接行うことができるものとします。ただし、ユーザーが情報の提供を希望しない旨を、事前または事後に弊社所定の方法で通知した場合は、本サービスの提供に必要な場合を除いて、情報の提供を行わないものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第14条&emsp;権利譲渡等</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;ユーザーは、本規約に定める場合を除くほか、本規約に基づくいかなる権利または義務も第三者に移転、譲渡その他の処分を行うことはできません。
                  </p>
                  <p>
                    2&emsp;弊社は本サービスにかかる事業を第三者に譲渡した場合には、当該事業譲渡に伴い本規約上の地位、本規約に基づく権利および義務ならびにユーザーの情報その他一切の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、当該事業譲渡につき、予め同意するものとします。なお、当該事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第15条&emsp;免責</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;本サービスの閲覧および利用はユーザー自身の責任において行ってください。それにより弊社または第三者が損害を被った場合は、当該ユーザー自身の費用と責任で解決するものとします。
                  </p>
                  <p>
                    2&emsp;弊社は、ユーザーのスポーツ観戦施設への予約や来店などの本サービスを通じての行動に関与しません。万一スポーツ観戦施設または第三者との間で紛争となった場合でも、当事者間で解決するものとし、弊社はその責任を負わないものとします。
                  </p>
                  <p>
                    3&emsp;本サービスの追加、変更、中断、終了によりユーザーに生じた損害について、弊社の責に帰する事由による場合を除き、いかなる責任も負いません。
                  </p>
                  <p>
                    4&emsp;アクセス過多、その他予期せぬ要因で表示速度の低下や障害等によって生じた損害について、弊社は、いかなる責任も負いません。
                  </p>
                  <p>
                    5&emsp;弊社は、本サービスを監視したり、保存する義務を負いません。
                  </p>
                  <p>
                    6&emsp;弊社は、本サービスにおける一切の動作保証、使用目的への適合性の保証、使用結果に関わる的確性や信頼性の保証をせず、かついかなる内容の瑕疵担保責任も、弊社の責に帰する事由による場合を除き、負いません。
                  </p>
                  <p>
                    7&emsp;弊社は、次に掲げる場合には、本サービスの内容を閲覧したり、保存したり、第三者に開示することができるものとします。弊社は、それによって生じたいかなる損害についても、弊社の責に帰する事由による場合を除き、一切責任を負いません。
                    <br />
                    (1)&emsp;本サービスの技術的不具合の原因を解明し、解消するために必要な場合。
                    <br />
                    (2)&emsp;裁判所や警察などの公的機関から、法令に基づく正式な照会を受けた場合。
                    <br />
                    (3)&emsp;本規約に違反する行為またはそのおそれのある行為が行われ、登録情報等の内容を確認する必要が生じたと弊社が判断した場合。
                    <br />
                    (4)&emsp;人の生命、身体および財産などに差し迫った危険があり、緊急の必要性があると弊社が判断した場合。
                    <br />
                    (5)&emsp;その他本サービスを適切に運営するために必要が生じた場合。
                  </p>
                  <p>
                    8&emsp;
                    弊社は、本規約に違反する行為またはそのおそれのある行為が行われたと信じるに足りる相当な理由があると判断した場合には、当該行為を行ったユーザーに対して、事前の通知をおこなうことなく、本サービスの利用制限、強制アカウント削除等の弊社が必要と考える措置を講じる場合がありますが、それによって生じたいかなる損害についても、弊社の責に帰する事由による場合を除き、一切責任を負いません。ユーザーは、弊社が本項の規定に基づいて行った措置に対して、異議を申し立てないものとします。
                  </p>
                  <p>
                    9&emsp;本サービスにおいて、弊社の責に帰する事由によりユーザーに損害が発生した場合は、弊社は、当該ユーザーが弊社に本サービスの対価として支払った一月分の料金または100円いずれか高い方を上限として損害賠償責任を負うものとします。ただし、弊社に故意または重過失がある場合は除きます。
                  </p>
                  <p>
                    10&emsp;本規約の定めにかかわらず、いかなる場合においても弊社は、本サービスに関し次に掲げる損害については一切の責任を負いません。
                    <br />
                    (1)&emsp;弊社の責に帰すべからざる事由から生じた損害。
                    <br />
                    (2)&emsp;弊社の予見の有無に関わらず、特別の事情から生じた損害。
                    <br />
                    (3)&emsp;サーバーのメンテナンスなど本サービスの提供にあたって必要不可欠な行為によって生じた損害。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  第16条&emsp;準拠法および管轄裁判所
                </h2>
                <div className={styles.detailText}>
                  <p>1&emsp;本規約の準拠法は、日本法とします。</p>
                  <p>
                    2&emsp;本サービスまたは本規約に関してユーザーとの間で疑義または争いが生じた場合には、誠意をもって協議することとしますが、それでもなお解決しない場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>第17条&emsp;その他</h2>
                <div className={styles.detailText}>
                  <p>
                    1&emsp;本規約の一部が法令に基づいて無効と判断されても、その他の規定は有効とします。{" "}
                  </p>
                  <p>
                    2&emsp;本規約の一部があるユーザーとの関係で無効とされ、または取り消された場合でも、本規約はその他のユーザーとの関係では有効とします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <div className={styles.detailText}>
                  <p>
                    <strong>附則</strong>
                    &emsp;本規約は2021年3月29日から施行します。
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </main>
      </div>
    </CommonLayout>
  );
};

export default TermsPage;
